<mat-toolbar color="accent">Edit Heidi Account Settings</mat-toolbar>

<form class="flex flex-col gap-6 p-4" [formGroup]="form">
  <pr-information-box>
    Heidi Health is an AI scribe that converts patient consultations into
    structured clinical notes. Link your account here to launch the
    transcription widget directly from patient clinical notes.
  </pr-information-box>
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Practice Account Email</mat-label>
    <input matInput formControlName="practiceEmail" />
  </mat-form-field>

  <div class="flex flex-col">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Personal Account Email</mat-label>
      <input matInput formControlName="stafferEmail" />
    </mat-form-field>
    <div class="flex flex-1 flex-col">
      <mat-checkbox formControlName="useAsDefault">
        Use this account by default
      </mat-checkbox>
      <span class="ml-2 text-xs opacity-70">
        <mat-icon class="icon-xs mr-1">info</mat-icon>
        Skips the account selection step by preferring your account over the
        practice's
      </span>
    </div>
  </div>

  <pt-buttons-container>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="form.invalid"
      (click)="save()"
    >
      Save
    </button>
  </pt-buttons-container>
</form>
